<div>
    <h5 class="mb-5">Import Confirmation</h5>
    <div class="form-group">
        <label>Effective Date</label>
        <div class="text-danger">
            {{effectiveDateError}}
        </div>
        <date-picker :format="'DD/MM/YYYY'" :elementId="'effectiveDateSelect'" :date="effectiveDate"
                     :initialiseDate="initialiseDate"
                     @dateChange="onEffectiveDateSelect"></date-picker>
    </div>
    <div class="text-danger">
        {{productsErrorMessage}}
    </div>
    <data-table :headings="productHeadings" :data="products" :hasActions="false" :hasNoFilter="true" :hasNoPaging="true">
        
    </data-table>
</div>